import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import BackgroundGradientColor from "./BackgroundGradientColor";
import BackgroundSingeColor from "./BackgroundSingeColor";
import { setIsSingleColorBackground } from "../../../../../redux/slices/qrSettings";

const QrBackground = () => {
  const { lang, isSingleColorBackground } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree,
    isSingleColorBackground: state.qrSettings.isSingleColorBackground,
  }));
  const dispatch = useDispatch();

  return (
    <>
      <div className="fw-bold fs-4 mb-3 mb-md-4 text-capitalize">
        {lang.background[0]}
      </div>
      <div
        key="inline-radio"
        className="d-flex justify-content-start gap-4 fs-7 flex-wrap"
      >
        <Form.Check
          checked={isSingleColorBackground === true}
          type="radio"
          label={lang.gradient[0]}
          name="single"
          id="qrBodyColor-single"
          onChange={() => dispatch(setIsSingleColorBackground(true))}
        />
        <Form.Check
          checked={isSingleColorBackground === false}
          type="radio"
          label={lang.gradient[1]}
          name="gradient"
          id="qrBodyColor-gradient"
          onChange={() => dispatch(setIsSingleColorBackground(false))}
        />
        <Form.Check
          checked={isSingleColorBackground === null}
          type="radio"
          label={lang.gradient[2]}
          name="transparent"
          id="qrBodyColor-transparent"
          onChange={() => dispatch(setIsSingleColorBackground(null))}
        />
      </div>
      {isSingleColorBackground === true ? (
        <BackgroundSingeColor />
      ) : isSingleColorBackground === false ? (
        <BackgroundGradientColor />
      ) : null}
    </>
  );
};

export default QrBackground;
